import React, { Fragment } from 'react';
import { TextInput, SelectInput, required, email } from 'react-admin';

import { ReferenceInput } from '~/components/ra';
import { Identity } from '~/types';
import validatePhoneNumber from '~/utils/validatePhoneNumber';

import { l } from './IdentityShow';

interface Props {
  edit?: boolean;
  record?: Identity;
}

const validateUsername = (value: string) => {
  if (value) {
    try {
      if (!/^[a-zA-Z0-9._\-+@]{3,32}$/.test(value)) {
        return { message: 'utils.validateUsername.error' };
      }
    } catch (error) {
      return { message: 'utils.validateUsername.error' };
    }
  }
};
const validateName = (value: string) => {
  if (value) {
    try {
      // Allowed only letters(any language), digits, dot(.), plus(+), underscore(_) and minus(-).
      if (!/^[\p{L}\d._+-]+$/u.test(value)) {
        return { message: 'utils.validateName.error' };
      }
    } catch (error) {
      return { message: 'utils.validateName.error' };
    }
  }
};

const IdentityForm = (props: Props) => {
  const { edit, record } = props;
  return (
    <Fragment>
      <TextInput
        source='username'
        label={l('username')}
        validate={[required(), validateUsername]}
        disabled={edit}
      />
      <TextInput source='firstName' label={l('firstName')} validate={[required(), validateName]} />
      <TextInput source='lastName' label={l('lastName')} validate={[required(), validateName]} />
      <TextInput source='email' label={l('email')} validate={[required(), email()]} />
      <TextInput source='phoneNumber' label={l('phoneNumber')} validate={[validatePhoneNumber]} />
      {record?.roleId !== 'support' && (
        <ReferenceInput
          source='roleId'
          reference='roles'
          label={l('roleId')}
          validate={[required()]}
        >
          <SelectInput optionText='name' validate={[required()]} />
        </ReferenceInput>
      )}
    </Fragment>
  );
};

export default IdentityForm;
